import { render, staticRenderFns } from "./PageCategoryEdit.vue?vue&type=template&id=8b7289b8"
import script from "./PageCategoryEdit.vue?vue&type=script&lang=js"
export * from "./PageCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports